export default function CasosUso() {
  const cases = [
    {
      icon: 'ri-shopping-cart-line',
      category: 'E-COMMERCE',
      title: 'Soporte de Ventas 24/7',
      description: 'Asiste a tus clientes en todo el proceso de compra, desde consultas de productos hasta seguimiento de pedidos.',
      metric: '95%',
      metricLabel: 'Satisfacción del Cliente',
      image: 'https://public.readdy.ai/ai/img_res/24b9981ebbc3a8712ef4fa14ea2c0a67.jpg'
    },
    {
      icon: 'ri-customer-service-2-line',
      category: 'SOPORTE TÉCNICO',
      title: 'Resolución Instantánea',
      description: 'Resuelve problemas técnicos comunes al instante, reduciendo la carga de tu equipo de soporte.',
      metric: '80%',
      metricLabel: 'Reducción de Tickets',
      image: 'https://readdy.ai/api/search-image?query=technical%20support%20dashboard%20with%20headset%20and%20tools%20icons%20in%20dark%20purple%20background%20with%20clean%20modern%20interface%20showing%20customer%20service%20elements&width=400&height=500&seq=case2&orientation=portrait'
    },
    {
      icon: 'ri-calendar-check-line',
      category: 'AGENDAMIENTO',
      title: 'Reservas Automáticas',
      description: 'Gestiona citas, reservas y agendamiento de servicios sin intervención humana, disponible 24/7.',
      metric: '3x',
      metricLabel: 'Más Reservas Completadas',
      image: 'https://readdy.ai/api/search-image?query=calendar%20scheduling%20interface%20with%20appointment%20slots%20and%20time%20management%20in%20dark%20teal%20background%20with%20modern%20clean%20design%20showing%20booking%20system&width=400&height=500&seq=case3&orientation=portrait'
    }
  ];

  return (
    <section id="casos-uso" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-[#0a0e27] to-[#1a1f3a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-cyan-400 text-xs sm:text-sm font-bold tracking-widest mb-3 sm:mb-4 uppercase">APLICACIONES REALES</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white px-4">
            Casos de Uso que
            <br />
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
              Transforman Negocios
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {cases.map((useCase, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-[#1a1f3a] to-[#0a0e27] rounded-2xl overflow-hidden border border-cyan-500/20 hover:border-cyan-500/60 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-cyan-500/20 cursor-pointer"
            >
              <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden">
                <div className="w-full h-full">
                  <img 
                    src={useCase.image} 
                    alt={useCase.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e27] via-[#0a0e27]/60 to-transparent"></div>
              </div>

              <div className="p-6 sm:p-8">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gradient-to-r from-cyan-500 to-purple-600 flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-cyan-500/50">
                  <i className={`${useCase.icon} text-2xl sm:text-3xl text-white`}></i>
                </div>

                <div className="mb-3 sm:mb-4">
                  <span className="text-[10px] sm:text-xs font-bold text-cyan-400 tracking-widest">{useCase.category}</span>
                </div>

                <h3 className="text-xl sm:text-2xl font-bold text-white mb-2 sm:mb-3">{useCase.title}</h3>
                <p className="text-sm sm:text-base text-gray-400 mb-4 sm:mb-6 leading-relaxed">{useCase.description}</p>

                <div className="pt-4 sm:pt-6 border-t border-cyan-500/20">
                  <div className="text-3xl sm:text-4xl font-extrabold text-cyan-400 mb-1">{useCase.metric}</div>
                  <div className="text-xs sm:text-sm text-gray-500">{useCase.metricLabel}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
